<template>
  <div class="timeblock">
    <div class="header">
      <img :src="iconSrc">
      <span ref="title">{{ title }}</span>
    </div>
    <div class="body">
      <div class="block" v-for="(item, index) in list" :key="index">
        <p class="date">
          <img src="../assets/time.png">
          {{ item.date }}
        </p>
        <router-link class="content" :to="item.url">{{ item.content }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeblock',
  props: {
    iconSrc: {
      String,
      default: require('../assets/blue-icon.png')
    },
    // [{date: '', content: '', url: ''}, ...]
    list: {
      type: Array,
      require: true
    },
    title: {
      type: String,
      required: false,
      default: '最新案例'
    },
    titleColor: {
      type: String,
      required: false,
      default: '#0087d3'
    }
  },
  mounted() {
    this.$refs.title.style.color = this.titleColor
  },
}
</script>

<style lang="scss" scoped>
$width: 230px;
  .timeblock {
    width: $width;
    // padding: 0 10px;
    .header {
      border-bottom: 3px solid #e3e3e3;
      padding: 5px;
      margin-bottom: 30px;
      font-size: 20px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
        margin-bottom: -4px;
      }
    }
    .block {
      width: 90%;
      padding: 15px 10px 15px 5px;
      border-bottom: 2px solid #dfdfdf;
      .date {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 10px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 7px;
        }
      }
    }
  }
</style>